import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const Conferences = () => {
  const [showHistory, setShowHistory] = useState(false);

  return (
    <div className="research-page">
      <div className="container">
        <h1 className="page-title">Conferences</h1>
        <p className="page-subtitle">Annual conferences bringing together solution-focused professionals from across Europe and beyond</p>
        
        {/* Current Conference Status */}
        <div style={{
          background: 'linear-gradient(135deg, #f0f9ff 0%, #dbeafe 100%)',
          borderRadius: '16px',
          padding: '2rem',
          marginBottom: '3rem',
          border: '1px solid #3b82f6'
        }}>
          <div style={{display: 'flex', alignItems: 'center', gap: '1rem', marginBottom: '1.5rem'}}>
            <div style={{fontSize: '2.5rem'}}>🎯</div>
            <div>
              <h2 style={{margin: 0, color: '#1e293b', fontSize: '1.8rem'}}>2026 EBTA Conference</h2>
              <p style={{margin: '0.5rem 0 0 0', color: '#1e40af', fontWeight: '600'}}>Olomouc, Czech Republic</p>
            </div>
          </div>
          <div style={{marginBottom: '1.5rem'}}>
            <div style={{display: 'flex', alignItems: 'center', gap: '1rem', marginBottom: '0.5rem'}}>
              <strong style={{color: '#1e40af'}}>📍 Where:</strong>
              <span style={{color: '#475569'}}>Olomouc, Czech Republic</span>
            </div>
            <div style={{display: 'flex', alignItems: 'center', gap: '1rem', marginBottom: '0.5rem'}}>
              <strong style={{color: '#1e40af'}}>📅 When:</strong>
              <span style={{color: '#475569'}}>18-20 September 2026</span>
            </div>
            <div style={{display: 'flex', alignItems: 'center', gap: '1rem', marginBottom: '1rem'}}>
              <strong style={{color: '#1e40af'}}>🎨 Theme:</strong>
              <span style={{color: '#475569', fontStyle: 'italic'}}>"PULS OF CHANGE"</span>
            </div>
          </div>
          <div style={{
            background: '#fef3c7',
            padding: '1rem 1.5rem',
            borderRadius: '8px',
            border: '1px solid #fde047'
          }}>
            <div style={{marginBottom: '0.5rem'}}>
              <strong style={{color: '#92400e'}}>📢 THE CONFERENCE WEBSITE IS LIVE!</strong>
              <span style={{color: '#92400e', marginLeft: '0.5rem'}}>Explore important details and deadlines for workshop proposal submissions and registration.</span>
            </div>
            <a
              href="https://ebta2026.cz/en/"
              target="_blank"
              rel="noopener noreferrer"
              style={{
                display: 'inline-block',
                marginTop: '0.5rem',
                padding: '0.5rem 1rem',
                background: '#92400e',
                color: 'white',
                borderRadius: '6px',
                textDecoration: 'none',
                fontWeight: '600',
                fontSize: '0.9rem',
                transition: 'all 0.3s ease'
              }}
              onMouseEnter={(e) => e.target.style.background = '#78350f'}
              onMouseLeave={(e) => e.target.style.background = '#92400e'}
            >
              Visit Conference Website →
            </a>
          </div>
        </div>

        {/* Conference Scholarship Section */}
        <div style={{
          background: 'linear-gradient(135deg, #f0fdf4 0%, #dcfce7 100%)',
          borderRadius: '16px',
          padding: '2rem',
          marginBottom: '3rem',
          border: '1px solid #059669'
        }}>
          <div style={{display: 'flex', alignItems: 'center', gap: '1rem', marginBottom: '1.5rem'}}>
            <div style={{fontSize: '2.5rem'}}>🎓</div>
            <div>
              <h2 style={{margin: 0, color: '#166534', fontSize: '1.8rem'}}>EBTA Conference Scholarship</h2>
              <p style={{margin: '0.5rem 0 0 0', color: '#059669', fontWeight: '600'}}>Three scholarships available</p>
            </div>
          </div>

          <div style={{marginBottom: '1.5rem'}}>
            <p style={{color: '#166534', fontSize: '1.1rem', lineHeight: '1.6', marginBottom: '1rem'}}>
              EBTA offers three conference scholarships to support practitioners who wish to attend the annual conference.
            </p>

            <div style={{
              background: '#ffffff',
              padding: '1.5rem',
              borderRadius: '12px',
              marginBottom: '1.5rem',
              border: '1px solid #bbf7d0'
            }}>
              <h3 style={{color: '#166534', fontSize: '1.2rem', fontWeight: '600', marginBottom: '1rem'}}>
                Scholarship Details
              </h3>
              <ul style={{color: '#475569', lineHeight: '1.8', margin: 0, paddingLeft: '1.5rem'}}>
                <li><strong>Open to all:</strong> Both EBTA members and non-members can apply</li>
                <li><strong>Coverage:</strong> The scholarship covers the full conference fee</li>
                <li><strong>Not included:</strong> Travel and accommodation costs are not covered</li>
                <li><strong>Decision:</strong> The Conference Task Group allocates the scholarships</li>
              </ul>
            </div>

            <div style={{
              background: '#ffffff',
              padding: '1.5rem',
              borderRadius: '12px',
              marginBottom: '1.5rem',
              border: '1px solid #bbf7d0'
            }}>
              <h3 style={{color: '#166534', fontSize: '1.2rem', fontWeight: '600', marginBottom: '1rem'}}>
                Application Requirements
              </h3>
              <ul style={{color: '#475569', lineHeight: '1.8', margin: 0, paddingLeft: '1.5rem'}}>
                <li>Complete the application form with required information</li>
                <li>Provide a conference feedback article for the next EBTA newsletter</li>
              </ul>
            </div>

            <div style={{
              background: '#dcfce7',
              padding: '1.5rem',
              borderRadius: '12px',
              border: '1px solid #bbf7d0'
            }}>
              <h3 style={{color: '#166534', fontSize: '1.2rem', fontWeight: '600', marginBottom: '1rem'}}>
                Application Form
              </h3>
              <div style={{color: '#475569', lineHeight: '1.6'}}>
                <p style={{marginBottom: '0.75rem'}}>Please provide the following information:</p>
                <ul style={{margin: 0, paddingLeft: '1.5rem', lineHeight: '1.8'}}>
                  <li>Name and first name</li>
                  <li>Date of birth</li>
                  <li>Country of residence</li>
                  <li>Work place/position</li>
                  <li>Reasons for the request</li>
                </ul>
              </div>
            </div>
          </div>

          <div style={{textAlign: 'center'}}>
            <a
              href="mailto:info@ebta.eu?subject=Conference Scholarship Application"
              style={{
                display: 'inline-block',
                background: '#059669',
                color: 'white',
                padding: '1rem 2rem',
                borderRadius: '8px',
                textDecoration: 'none',
                fontWeight: '600',
                fontSize: '1rem',
                transition: 'all 0.3s ease',
                boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)'
              }}
              onMouseEnter={(e) => {
                e.target.style.background = '#047857';
                e.target.style.transform = 'translateY(-2px)';
              }}
              onMouseLeave={(e) => {
                e.target.style.background = '#059669';
                e.target.style.transform = 'translateY(0)';
              }}
            >
              Apply for Scholarship →
            </a>
          </div>
        </div>

        {/* Organize Conference Section */}
        <div style={{
          background: 'white',
          borderRadius: '16px',
          padding: '2rem',
          marginBottom: '3rem',
          boxShadow: '0 4px 20px rgba(0, 0, 0, 0.08)',
          border: '1px solid #e2e8f0'
        }}>
          <div style={{display: 'flex', alignItems: 'center', gap: '1rem', marginBottom: '1.5rem'}}>
            <div style={{fontSize: '2.5rem'}}>🌟</div>
            <div>
              <h2 style={{margin: 0, color: '#1e293b', fontSize: '1.8rem'}}>Organize an EBTA Conference?</h2>
              <p style={{margin: '0.5rem 0 0 0', color: '#64748b'}}>Host a future EBTA conference</p>
            </div>
          </div>
          <div style={{marginBottom: '1.5rem'}}>
            <p style={{color: '#475569', lineHeight: '1.6', marginBottom: '1rem'}}>
              EBTA welcomes applications from solution-focused teams to host future EBTA conferences. 
              An EBTA conference usually draws about 150-250 participants.
            </p>
            <div style={{
              background: '#f0f9ff',
              padding: '1rem 1.5rem',
              borderRadius: '8px',
              border: '1px solid #bfdbfe',
              marginBottom: '1rem'
            }}>
              <strong style={{color: '#1e40af'}}>📅 Conference Schedule:</strong>
              <span style={{color: '#1e40af', marginLeft: '0.5rem'}}>
                Every year at the end of September from Friday morning 09:00 until Sunday afternoon 12:30
              </span>
            </div>
            <p style={{color: '#475569', lineHeight: '1.6'}}>
              If you're interested in organizing a future EBTA conference, please get in touch with us to discuss your proposal.
            </p>
          </div>
        </div>

        {/* Related Links */}
        <div className="research-grid" style={{marginBottom: '3rem'}}>
          <Link to="/research/grant" className="research-card">
            <div className="card-icon">🏆</div>
            <h3>EBTA Grant Awards</h3>
            <p>Learn about our research grant program and see the history of awarded grants from 2001 to 2025.</p>
            <div className="card-arrow">→</div>
          </Link>

          <Link to="/contact" className="research-card">
            <div className="card-icon">📧</div>
            <h3>Contact Us</h3>
            <p>Get in touch for more information about upcoming conferences and events.</p>
            <div className="card-arrow">→</div>
          </Link>

          <Link to="/membership" className="research-card">
            <div className="card-icon">👥</div>
            <h3>Become a Member</h3>
            <p>Join EBTA to receive priority access to conference information and member benefits.</p>
            <div className="card-arrow">→</div>
          </Link>
        </div>

        {/* Conference History Section */}
        <div style={{
          background: 'white',
          borderRadius: '16px',
          padding: '2rem',
          boxShadow: '0 4px 20px rgba(0, 0, 0, 0.08)',
          border: '1px solid #e2e8f0'
        }}>
          <div style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '1.5rem'}}>
            <div style={{display: 'flex', alignItems: 'center', gap: '1rem'}}>
              <div style={{fontSize: '2.5rem'}}>📚</div>
              <h2 style={{margin: 0, color: '#1e293b', fontSize: '1.8rem'}}>Conference History</h2>
            </div>
            <button
              onClick={() => setShowHistory(!showHistory)}
              style={{
                background: showHistory ? 'linear-gradient(135deg, #dc2626, #b91c1c)' : 'linear-gradient(135deg, #3b82f6, #1d4ed8)',
                color: 'white',
                border: 'none',
                padding: '0.75rem 1.5rem',
                borderRadius: '8px',
                fontSize: '1rem',
                fontWeight: '600',
                cursor: 'pointer',
                transition: 'all 0.3s ease',
                display: 'flex',
                alignItems: 'center',
                gap: '0.5rem'
              }}
            >
              {showHistory ? '❌ Hide History' : '📖 Show History'}
            </button>
          </div>
          
          <p style={{color: '#64748b', marginBottom: showHistory ? '2rem' : 0}}>
            Explore the rich history of EBTA conferences from past years.
          </p>

          {showHistory && (
            <div style={{
              background: '#f8fafc',
              padding: '2rem',
              borderRadius: '12px',
              border: '1px solid #e2e8f0'
            }}>
              <div style={{marginBottom: '2rem'}}>
                <h3 style={{color: '#1e293b', fontSize: '1.4rem', fontWeight: '600', marginBottom: '1rem'}}>
                  📅 Conference Schedule
                </h3>
                <div style={{background: 'white', padding: '1.5rem', borderRadius: '8px', border: '1px solid #e2e8f0', marginBottom: '1.5rem'}}>
                  <div style={{marginBottom: '1rem'}}>
                    <strong style={{color: '#059669'}}>2026 – Olomouc, Czech Republic</strong>
                    <p style={{margin: '0.5rem 0', color: '#64748b'}}>
                      Theme: "Puls of Change" – Organized by Leoš Zatloukal, Palacký University in Olomouc
                    </p>
                  </div>
                </div>
              </div>

              <div>
                <h3 style={{color: '#1e293b', fontSize: '1.4rem', fontWeight: '600', marginBottom: '1rem'}}>
                  📚 Complete Conference History (1993-2024)
                </h3>
                <div style={{background: 'white', padding: '1.5rem', borderRadius: '8px', border: '1px solid #e2e8f0'}}>
                  <div style={{display: 'grid', gap: '1rem'}}>
                    
                    <div style={{padding: '1rem', background: '#f8fafc', borderRadius: '6px', borderLeft: '3px solid #3b82f6'}}>
                      <strong style={{color: '#1e293b'}}>2025 – Roskilde, Denmark</strong>
                      <p style={{margin: '0.5rem 0', color: '#64748b'}}>
                        Theme: "In between" – Organized by Nete Fosmark Guldbrandsen, Lena Gadegaard, Michael Petersen, Kari Terndrup Hvilsom and Anne-Marie Wulf
                      </p>
                    </div>

                    <div style={{padding: '1rem', background: '#f8fafc', borderRadius: '6px', borderLeft: '3px solid #3b82f6'}}>
                      <strong style={{color: '#1e293b'}}>2024 – Tenerife, Spain</strong>
                      <p style={{margin: '0.5rem 0', color: '#64748b'}}>
                        Theme: "Ripple effect: expanding hope" – Organized by Toni Medina, Asociación para el desarrollo de la práctica centrada en soluciones
                      </p>
                    </div>

                    <div style={{padding: '1rem', background: '#f8fafc', borderRadius: '6px', borderLeft: '3px solid #3b82f6'}}>
                      <strong style={{color: '#1e293b'}}>2023 – Sosnowiec, Poland</strong>
                      <p style={{margin: '0.5rem 0', color: '#64748b'}}>
                        Theme: "Exploring resilience" – Organized by Magdalena Szutarska and Stowarzyszenie Moc Wsparcia from Sosnowiec
                      </p>
                    </div>

                    <div style={{padding: '1rem', background: '#f8fafc', borderRadius: '6px', borderLeft: '3px solid #3b82f6'}}>
                      <strong style={{color: '#1e293b'}}>2022 – Bremen, Germany</strong>
                      <p style={{margin: '0.5rem 0', color: '#64748b'}}>
                        Theme: "There's always hope" – Organized by Manfred Vogt and NIK TEAM
                      </p>
                    </div>

                    <div style={{padding: '1rem', background: '#fef2f2', borderRadius: '6px', borderLeft: '3px solid #dc2626'}}>
                      <strong style={{color: '#dc2626'}}>2020-2021 – COVID BREAK</strong>
                      <p style={{margin: '0.5rem 0', color: '#64748b'}}>
                        No conferences held due to the COVID-19 pandemic
                      </p>
                    </div>

                    <div style={{padding: '1rem', background: '#f8fafc', borderRadius: '6px', borderLeft: '3px solid #3b82f6'}}>
                      <strong style={{color: '#1e293b'}}>2019 – Florence, Italy</strong>
                      <p style={{margin: '0.5rem 0', color: '#64748b'}}>
                        Theme: "As if…" – Organized by Fondazione Franceschi Onlus
                      </p>
                    </div>

                    <div style={{padding: '1rem', background: '#f8fafc', borderRadius: '6px', borderLeft: '3px solid #3b82f6'}}>
                      <strong style={{color: '#1e293b'}}>2018 – Sofia, Bulgaria</strong>
                      <p style={{margin: '0.5rem 0', color: '#64748b'}}>
                        Theme: "21st Century Solutions, 21 years later…" – Organized by Plamen Panayotov, Boyan Strahilov
                      </p>
                    </div>

                    <div style={{padding: '1rem', background: '#fef3c7', borderRadius: '6px', borderLeft: '3px solid #f59e0b'}}>
                      <strong style={{color: '#92400e'}}>2017 – Frankfurt</strong>
                      <p style={{margin: '0.5rem 0', color: '#64748b'}}>
                        SF World Conference
                      </p>
                    </div>

                    <div style={{padding: '1rem', background: '#f8fafc', borderRadius: '6px', borderLeft: '3px solid #3b82f6'}}>
                      <strong style={{color: '#1e293b'}}>2016 – Bruges</strong>
                      <p style={{margin: '0.5rem 0', color: '#64748b'}}>
                        Theme: "The map is not the territory" – Organized by Korzybski Institute
                      </p>
                    </div>

                    <div style={{padding: '1rem', background: '#f8fafc', borderRadius: '6px', borderLeft: '3px solid #3b82f6'}}>
                      <strong style={{color: '#1e293b'}}>2015 – Vienna</strong>
                      <p style={{margin: '0.5rem 0', color: '#64748b'}}>
                        Theme: "Don't think – observe" – Organized by Veronika Kotrba, Ralph Miarka, Claudia Lembach, Ferdinand Wolf
                      </p>
                    </div>

                    <div style={{padding: '1rem', background: '#f8fafc', borderRadius: '6px', borderLeft: '3px solid #3b82f6'}}>
                      <strong style={{color: '#1e293b'}}>2014 – Leeuwarden</strong>
                      <p style={{margin: '0.5rem 0', color: '#64748b'}}>
                        Theme: "Delta - Resources United" – Organized by Ieta Berghuis, Lammie Lamberts, Rienk Versloot, Jos Kienhuis
                      </p>
                    </div>

                    <div style={{padding: '1rem', background: '#f8fafc', borderRadius: '6px', borderLeft: '3px solid #3b82f6'}}>
                      <strong style={{color: '#1e293b'}}>2013 – Bern</strong>
                      <p style={{margin: '0.5rem 0', color: '#64748b'}}>
                        Theme: "I'm my style" – Organized by The NLA Network for SF work Switzerland
                      </p>
                    </div>

                    <div style={{padding: '1rem', background: '#f8fafc', borderRadius: '6px', borderLeft: '3px solid #3b82f6'}}>
                      <strong style={{color: '#1e293b'}}>2012 – Torun</strong>
                      <p style={{margin: '0.5rem 0', color: '#64748b'}}>
                        Theme: "Upside down – SF paradigms – revolutions & evolutions" – Organized by Tomasz Switek, Artur Lewinski, Jacek Szczepkowski and volunteers from Warsaw and Toruń
                      </p>
                    </div>

                    <div style={{padding: '1rem', background: '#f8fafc', borderRadius: '6px', borderLeft: '3px solid #3b82f6'}}>
                      <strong style={{color: '#1e293b'}}>2011 – Dresden</strong>
                      <p style={{margin: '0.5rem 0', color: '#64748b'}}>
                        Theme: "Frames and beyond – How the frames influence our doing and the doing influences" – Organized by The f.l.o.w. association and NIK
                      </p>
                    </div>

                    <div style={{padding: '1rem', background: '#f8fafc', borderRadius: '6px', borderLeft: '3px solid #3b82f6'}}>
                      <strong style={{color: '#1e293b'}}>2010 – Malmö</strong>
                      <p style={{margin: '0.5rem 0', color: '#64748b'}}>
                        Theme: "Bridges" – Organized by Harry Korman – SIKT
                      </p>
                    </div>

                    <div style={{padding: '1rem', background: '#f8fafc', borderRadius: '6px', borderLeft: '3px solid #3b82f6'}}>
                      <strong style={{color: '#1e293b'}}>2009 – Helsinki</strong>
                      <p style={{margin: '0.5rem 0', color: '#64748b'}}>
                        Theme: "Imagine" – Organized by TaitoBa, Helsinki University Palmenia, Ratkes ry
                      </p>
                    </div>

                    <div style={{padding: '1rem', background: '#f8fafc', borderRadius: '6px', borderLeft: '3px solid #3b82f6'}}>
                      <strong style={{color: '#1e293b'}}>2008 – Lyon</strong>
                      <p style={{margin: '0.5rem 0', color: '#64748b'}}>
                        Theme: "Différences et changements" – Organized by Pascal Soubeyrand, Hélèn Dellucci and Association Différences et Changements
                      </p>
                    </div>

                    <div style={{padding: '1rem', background: '#f8fafc', borderRadius: '6px', borderLeft: '3px solid #3b82f6'}}>
                      <strong style={{color: '#1e293b'}}>2007 – Brugge</strong>
                      <p style={{margin: '0.5rem 0', color: '#64748b'}}>
                        Organized by Korzybski Institute
                      </p>
                    </div>

                    <div style={{padding: '1rem', background: '#f8fafc', borderRadius: '6px', borderLeft: '3px solid #3b82f6'}}>
                      <strong style={{color: '#1e293b'}}>2006 – Krakow</strong>
                      <p style={{margin: '0.5rem 0', color: '#64748b'}}>
                        Organized by Centrum Terapii Krótkoterminowej
                      </p>
                    </div>

                    <div style={{padding: '1rem', background: '#f8fafc', borderRadius: '6px', borderLeft: '3px solid #3b82f6'}}>
                      <strong style={{color: '#1e293b'}}>2005 – Salamanca</strong>
                      <p style={{margin: '0.5rem 0', color: '#64748b'}}>
                        Organized by Dr. Mark Beyebach and team
                      </p>
                    </div>

                    <div style={{padding: '1rem', background: '#f8fafc', borderRadius: '6px', borderLeft: '3px solid #3b82f6'}}>
                      <strong style={{color: '#1e293b'}}>2004 – Amsterdam</strong>
                      <p style={{margin: '0.5rem 0', color: '#64748b'}}>
                        Theme: "Leading from one step behind. What works? Our clients will tell us!" – Organized by Arnoud Huibers and team
                      </p>
                    </div>

                    <div style={{padding: '1rem', background: '#f0fdf4', borderRadius: '6px', borderLeft: '3px solid #059669'}}>
                      <strong style={{color: '#166534'}}>2003 – Berlin</strong>
                      <p style={{margin: '0.5rem 0', color: '#64748b'}}>
                        Theme: "Let's Talk About Solutions" – 10 year anniversary of EBTA Conferences – Organized by NIK
                      </p>
                    </div>

                    <div style={{padding: '1rem', background: '#f8fafc', borderRadius: '6px', borderLeft: '3px solid #3b82f6'}}>
                      <strong style={{color: '#1e293b'}}>2002 – Cardiff</strong>
                    </div>

                    <div style={{padding: '1rem', background: '#f8fafc', borderRadius: '6px', borderLeft: '3px solid #3b82f6'}}>
                      <strong style={{color: '#1e293b'}}>2001 – Dublin</strong>
                    </div>

                    <div style={{padding: '1rem', background: '#f8fafc', borderRadius: '6px', borderLeft: '3px solid #3b82f6'}}>
                      <strong style={{color: '#1e293b'}}>2000 – Turku</strong>
                      <p style={{margin: '0.5rem 0', color: '#64748b'}}>
                        Organized by Turku Summer University
                      </p>
                    </div>

                    <div style={{padding: '1rem', background: '#f8fafc', borderRadius: '6px', borderLeft: '3px solid #3b82f6'}}>
                      <strong style={{color: '#1e293b'}}>1999 – Carlisle</strong>
                      <p style={{margin: '0.5rem 0', color: '#64748b'}}>
                        Theme: "Solutions not problems" – Organized by Dr Alasdair Macdonald and team
                      </p>
                    </div>

                    <div style={{padding: '1rem', background: '#f8fafc', borderRadius: '6px', borderLeft: '3px solid #3b82f6'}}>
                      <strong style={{color: '#1e293b'}}>1998 – Salamanca</strong>
                      <p style={{margin: '0.5rem 0', color: '#64748b'}}>
                        Organized by Mark Beyebach and team
                      </p>
                    </div>

                    <div style={{padding: '1rem', background: '#f8fafc', borderRadius: '6px', borderLeft: '3px solid #3b82f6'}}>
                      <strong style={{color: '#1e293b'}}>1997 – Sofia (Spring) and Bruges (Autumn)</strong>
                    </div>

                    <div style={{padding: '1rem', background: '#f8fafc', borderRadius: '6px', borderLeft: '3px solid #3b82f6'}}>
                      <strong style={{color: '#1e293b'}}>1996 – Paris (Spring) and Lodz (Autumn)</strong>
                    </div>

                    <div style={{padding: '1rem', background: '#f8fafc', borderRadius: '6px', borderLeft: '3px solid #3b82f6'}}>
                      <strong style={{color: '#1e293b'}}>1995 – London (Spring) and Bremen (Autumn)</strong>
                    </div>

                    <div style={{padding: '1rem', background: '#f8fafc', borderRadius: '6px', borderLeft: '3px solid #3b82f6'}}>
                      <strong style={{color: '#1e293b'}}>1994 – Bruges (Spring) and Stockholm (Autumn)</strong>
                    </div>

                    <div style={{padding: '1rem', background: '#fef3c7', borderRadius: '6px', borderLeft: '3px solid #f59e0b'}}>
                      <strong style={{color: '#92400e'}}>1993 – New Orleans and Paris</strong>
                      <p style={{margin: '0.5rem 0', color: '#64748b'}}>
                        🎉 <strong>EBTA was founded at the New Orleans Conference in honor of John Weakland in 1993</strong>
                      </p>
                    </div>

                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Conferences;
